var map = {
	"./AMPL-logo.png": 1102,
	"./BAT-logo.png": 1103,
	"./BPT-logo.png": 1104,
	"./BUSD-logo.png": 1105,
	"./COMP-logo.png": 1106,
	"./CRV-logo.png": 1107,
	"./DAI-logo.png": 1108,
	"./ETH-logo.png": 1109,
	"./FTM-logo.png": 1110,
	"./KNC-logo.png": 1111,
	"./LEND-logo.png": 1112,
	"./LINK-logo.png": 1113,
	"./MANA-logo.png": 1114,
	"./MKR-logo.png": 1115,
	"./REP-logo.png": 1116,
	"./SAI-logo.png": 1117,
	"./SNX-logo.png": 1118,
	"./SUSD-logo.png": 1119,
	"./TUSD-logo.png": 1120,
	"./USDC-logo.png": 1121,
	"./USDT-logo.png": 1122,
	"./WETH-logo.png": 1123,
	"./YFI-logo.png": 1124,
	"./YFII-logo.png": 475,
	"./ZRX-logo.png": 1125,
	"./aLINK-logo.png": 1126,
	"./cCrv-logo.png": 1127,
	"./cUSDC-logo.png": 1128,
	"./cUSDT-logo.png": 1129,
	"./iDAI-logo.png": 1130,
	"./wBTC-logo.png": 1131,
	"./yCRV-logo.png": 1132,
	"./ycUSDC-logo.png": 1133,
	"./ycUSDT-logo.png": 1134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1101;